import { useEffect } from 'react';


const Scope = ({ scopeSection }) => {
 

  console.log(scopeSection);

  if (!scopeSection) return null;

  return (
    <section className="mb-3">
      <div className="container">
        <h2 className="sec-title text-center">
          {scopeSection.heading}
        </h2>
        <div className="row ">
          <ul className="list-unstyled ">
            {Object.values(scopeSection.scope_points || {}).map((point, index) => (
              <li
                key={index}
                className="mb-3"
                
              >
                <i className={`me-2 fa ${point.icon_class}`}></i>
                {point.text}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Scope;
